export default __webpack_public_path__ + "static/media/in-store-support.c2dc66c4.svg";